import { apiFetch } from './client'

export type EnquiryStatus =
  | 'new'
  | 'in_progress'
  | 'responded'
  | 'converted'
  | 'closed'

export const ENQUIRY_STATUSES: readonly EnquiryStatus[] = [
  'new',
  'in_progress',
  'responded',
  'converted',
  'closed',
]

export type Enquiry = {
  id: string
  reference: string
  full_name: string
  email: string
  phone: string | null
  whatsapp: string | null
  country_of_origin: string
  specialty: string | null
  preferred_hospital: string | null
  preferred_dates_text: string | null
  condition_description: string | null
  mobility: string | null
  medical_history_url: string | null
  status: EnquiryStatus
  created_at: string
}

export type EnquiriesPage = {
  data: Enquiry[]
  page: { next_cursor: string | null; limit: number }
}

export const ENQUIRIES_KEY = ['admin', 'enquiries'] as const

/** GET /api/v1/admin/enquiries — concierge queue, newest-first, keyset-paged,
 * optionally filtered by status (amtc_admin only). */
export async function fetchEnquiries(
  token: string | null,
  opts: { cursor?: string | null; status?: EnquiryStatus | null; q?: string } = {},
): Promise<EnquiriesPage> {
  const params = new URLSearchParams()
  if (opts.status) params.append('status', opts.status)
  if (opts.cursor) params.append('cursor', opts.cursor)
  if (opts.q) params.append('q', opts.q)
  const qs = params.toString()
  return apiFetch<EnquiriesPage>(
    `/api/v1/admin/enquiries${qs ? `?${qs}` : ''}`,
    { token },
  )
}
